export const SET_CROP_BOUNDS = 'SET_CROP_BOUNDS';
export const SET_ZOOM = 'SET_ZOOM';

export const setCropBounds = bounds => {
  return { type: SET_CROP_BOUNDS, payload: bounds };
};

export const setZoom = zoom => {
  return { type: SET_ZOOM, payload: zoom };
};
